import { Alert } from '@statsbomb/kitbag-components';
import { useAtom } from 'jotai';
import React from 'react';
import { messageAwaitingApprovalActionsAtom } from '../../atoms/messages';

export function AwaitingApprovalActionMessages() {
  const [actionMessage, setActionMessage] = useAtom(
    messageAwaitingApprovalActionsAtom,
  );

  return actionMessage ? (
    <Alert
      onDismiss={() => {
        setActionMessage('');
      }}
    >
      {actionMessage}
    </Alert>
  ) : null;
}

export default { AwaitingApprovalActionMessages };
